module.exports = __webpack_public_path__ + "static/media/img_11.041bd823.png";